import * as React from 'react';
import { contact } from '../../../../model/contact';
import { Grid, withStyles, StyledComponentProps, Hidden, Divider, Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import Tags from './Tags';
import TextField from '../../../../ui-components/TextField/TextField';
import Avatar from './Avatar';
import { styles } from './styles';
import RoomList from './RoomList';
import { IState as IRoomState } from '../../../room/store/state';
import { IActions as IRoomActions, actionCreator as roomActions } from '../../../room/store/action/creators';
import { IActions as IContactActions, actionCreator as contactActions } from '../../../../common/store/contacts/actions/creators';
import { connect } from 'react-redux';
import { IApplicationState } from '../../../../store/ApplicationState';
import moment from 'moment';
import Button from '../../../../ui-components/Button/Button';
import SaveIconButton from '../../../../ui-components/Button/SaveIconButton';
// Subscription
import { contactInsurance, contactMedicalExamination, contactSubscription } from '../../../../model/contactsubscription';
import { IState as ISubscriptionState } from '../../../../common/store/subscriptions/state';
import { IActions as ISubscriptionActions, actionCreator as subscriptionsActions } from '../../../../common/store/subscriptions/actions/creators';
import { ContactPurchasedList } from '../Subscription/ContactPurchasedList';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import Paper from '../../../../ui-components/Containers/Paper';
import UpdateSubscriptionDialog from '../Subscription/UpdateSubscriptionDialog';
// Icons
import { ReactComponent as Auth0 } from '../../../../images/icons/auth0.svg';
import { ReactComponent as Google } from '../../../../images/icons/google.svg';
import { ReactComponent as Apple } from '../../../../images/icons/apple.svg';
import QRCode from 'react-qr-code';


interface IProps extends ISubscriptionActions, ISubscriptionState, IRoomActions, IRoomState, IContactActions, StyledComponentProps {
    contact: contact;
    contactSubscriptions: contactSubscription[];
    isLoadingContact: boolean;
    isLoadingSubcriptions: boolean;
    blockAccessOn?: Date;
    openContactReservationDialog: () => void;
    openReminderDialog: () => void;
    openInformationDialog: () => void;
    loadContactPurchased: (id: string, medical: boolean, subscription: boolean, insurance: boolean) => void;
    addSubscriptionType: (tipo: string) => void;
    openContactAccessDialog: () => void;
}

interface IInternalState {
    blockAccessOn: Date;
    greenPassExpireOn: Date;
    cardNumber: string;
    showScheda: boolean;
    titleScheda: string;
    showAccessi: boolean;
    showAbbonamenti: boolean;
    itemToUpdate?: contactSubscription | contactMedicalExamination | contactInsurance;
    openUpdateSubscriptionDialog: boolean;
    setFilterAttivi: boolean;
    setFilterAbbonamenti: boolean;
    setFilterVisitemediche: boolean;
    setFilterIscrizione: boolean;
    copiedUserId: boolean;
}

class CompContainer extends React.Component<Partial<IProps>, IInternalState> {
    state = {
        blockAccessOn: this.props.blockAccessOn,
        cardNumber: this.props.contact?.cardNumber,
        greenPassExpireOn: this.props.contact?.greenPass?.expiresOn,
        showScheda: false,
        showAccessi: true,
        showAbbonamenti: true,
        titleScheda: "Scheda", subscriptionList: undefined,
        openUpdateSubscriptionDialog: false,
        itemToUpdate: null,
        setFilterAttivi: true,
        setFilterAbbonamenti: false,
        setFilterVisitemediche: false,
        setFilterIscrizione: false,
        copiedUserId: false,
    }

    //const [subscriptionList, setSubscriptionList] = React.useState<subscription>(props.subscription);
    componentDidMount() {
        if (!this.props.rooms || this.props.rooms.length === 0) {
            this.props.loadRooms();
        }
        if (this.props.contactMedical == null
            && this.props.contactInsurances == null
            && this.props.contactMedical == null) {
            this.props.loadContactPurchased(this.props.contact.sub, false, false, false);
            // console.info(this.props.contactMedical);
            // console.info(this.props.contactInsurances);
            // console.info(this.props.contactMedical);
        }
        var svg = document.getElementById('qrCode');
        svg.querySelector("svg").setAttribute('height', "40");
        svg.querySelector("svg").setAttribute('width', "40");
        svg.querySelector("svg").setAttribute('viewBox', "0 0 25 25");
    }

    getLogo = (sub: string) => {
        // console.log("-------------------------", this.props.contact.sub)
        let s = { marginLeft: '5px', marginRight: '5px' };

        // let s = {};
        if (sub.startsWith('google'))
            return <Google onClick={() => this.clickLogo(sub)} style={s} />
        else if (sub.startsWith('apple'))
            return <Apple onClick={() => this.clickLogo(sub)} style={s} />
        else if (sub.startsWith('auth0'))
            return <Auth0 onClick={() => this.clickLogo(sub)} style={s} />
        else
            return <></>
    }

    clickLogo = (sub: string) => {
        this.setState({ copiedUserId: true });
        setTimeout(() => {
            this.setState({ copiedUserId: false });
        }, 2500);
        navigator.clipboard.writeText(sub)
    }

    openContactScheda = () => {
        var _showScheda: boolean = !this.state.showScheda;
        var titolo: string = _showScheda ? "Abbonamenti" : "Scheda";
        this.setState({ showAccessi: false, showScheda: (titolo === "Abbonamenti"), showAbbonamenti: (titolo === "Scheda"), titleScheda: titolo });
    }

    openContactAccessi = () => {
        // var _showAccessi: boolean = !this.state.showAccessi;
        // var titolo: string = showScheda ? "Scheda" :  "Abbonamenti";
        this.setState({ showScheda: false, showAccessi: true, showAbbonamenti: false });
    }

    addSubscription = () => {
        this.props.addSubscriptionType('subscription');
    }

    addMedical = () => {
        this.props.addSubscriptionType('medical');
    }

    addInsurance = () => {
        this.props.addSubscriptionType('insurance');
    }

    isExpired = (expireDate: Date): any => {
        // console.log("expireDate", expireDate)
        // if (expireDate == null)
        //     return this.props.classes.greenPassContainer;
        return (expireDate !== undefined && moment(expireDate).toDate() <= (new Date())) ?
            { borderColor: 'red', borderStyle: 'solid', borderSize: '1px' } :
            { borderColor: '#90ee90', borderStyle: 'solid', borderSize: '1px' };
    }

    setOpenUpdateSubscriptionDialog = (open: boolean, item: contactSubscription | contactMedicalExamination | contactInsurance = null) => {
        // console.log("setOpenUpdateSubscriptionDialog", typeof item, item);
        // if (item !== null) {
        //     console.log("test object", typeof item)
        //     console.log("test is subscription:", ("subscriptionTimestamp" in item ? true : false))
        //     console.log("test is insurance:", ("insuranceTimestamp" in item ? true : false))
        //     console.log("test is medicalexam:", ("medicalExaminationTimestamp" in item ? true : false))
        // }
        this.setState({ openUpdateSubscriptionDialog: open, itemToUpdate: item });
    }

    updateSubscription = (item: contactSubscription) => {
        // console.info("-------------------------------------------------subscription", typeof item, item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.saveContactSubscription(this.props.contact.sub, item);
    }

    removeSingleAccess = (item: contactSubscription) => {
        // console.info("-------------------------------------------------subscription", typeof item, item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.removeAccessContactSubscription(this.props.contact.sub, item);
    }

    deleteSubscription = (item: contactSubscription) => {
        // console.info("-------------------------------------------------subscription", typeof item, item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.deleteContactSubscription(this.props.contact.sub, item);
    }

    updateInsurance = (item: contactInsurance) => {
        // console.info("-------------------------------------------------insurance")
        // console.info(item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.saveContactInsurance(this.props.contact.sub, item);
    }

    deleteInsurance = (item: contactInsurance) => {
        // console.info("-------------------------------------------------insurance")
        // console.info(item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.deleteContactInsurance(this.props.contact.sub, item);
    }

    updateMedicalExamination = (item: contactMedicalExamination) => {
        console.info("-------------------------------------------------update medical", item)
        // console.info(item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.saveContactMedical(this.props.contact.sub, item);
    }

    deleteMedicalExamination = (item: contactMedicalExamination) => {
        console.info("-------------------------------------------------delete medical", item)
        // console.info(item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.setState({ openUpdateSubscriptionDialog: false, itemToUpdate: null });
        this.props.deleteContactMedical(this.props.contact.sub, item);
    }

    changeFilterAttivi = () => {
        this.setState({ setFilterAttivi: !this.state.setFilterAttivi })
        if (this.state.setFilterAttivi === false) {
            // Ho richiesto di caricare gli abbonamenti attivi
            // Spengo gli altri check e carico gli attivi
            this.setState({ setFilterIscrizione: false });
            this.setState({ setFilterVisitemediche: false });
            this.setState({ setFilterAbbonamenti: false });
            this.props.loadContactPurchased(this.props.contact.sub, false, false, false);
        }
    }

    changeFilterInsurance = () => {
        this.props.loadContactPurchased(this.props.contact.sub, this.state.setFilterVisitemediche, this.state.setFilterAbbonamenti, !this.state.setFilterIscrizione);
        this.setState({ setFilterIscrizione: !this.state.setFilterIscrizione });
        if (this.state.setFilterIscrizione === false) {
            // Ho richiesto di caricare TUTTE LE ISCRIZIONI
            this.setState({ setFilterAttivi: false });
        }
    }

    changeFilterMedical = () => {
        this.props.loadContactPurchased(this.props.contact.sub, !this.state.setFilterVisitemediche, this.state.setFilterAbbonamenti, this.state.setFilterIscrizione);
        this.setState({ setFilterVisitemediche: !this.state.setFilterVisitemediche });
        if (this.state.setFilterVisitemediche === false) {
            // Ho richiesto di caricare TUTTE LE VISITE MEDICHE
            this.setState({ setFilterAttivi: false });
        }
    }

    changeFilterSubscription = () => {
        this.props.loadContactPurchased(this.props.contact.sub, this.state.setFilterVisitemediche, !this.state.setFilterAbbonamenti, this.state.setFilterIscrizione);
        this.setState({ setFilterAbbonamenti: !this.state.setFilterAbbonamenti });
        if (this.state.setFilterAbbonamenti === false) {
            // Ho richiesto di caricare TUTTI GLI ABBONAMENTI
            this.setState({ setFilterAttivi: false });
        }
    }

    isEmpty = (str) => (!str?.length);

    openSvg = () => {
        var svgbase = document.getElementById('qrCode').children[0];
        var svg = svgbase.cloneNode(true) as HTMLElement;
        // we need to handle a user gesture to use 'open'
        var win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=400,top=100,left=100");

        svg.setAttribute("width", "100mm");
        svg.setAttribute("height", "100mm");
        win.document.body.innerHTML = svg.outerHTML; //.replace(/40/g,'100');
        win.focus();
        // win.print(); 
    }

    getTooltipMessage() {
        if (this.state.copiedUserId)
            return "Copiato!"
        else
            return "Click per copiare \"userId\" dell'utente"
    }

    // moment.locale('it');

    render() {
        return (this.props.contact ?
            <Grid container>
                <Grid item xs={3} className={this.props.classes.contactReservationButtonContainer}>
                    <Button className={this.props.classes.contactReservationButton} onClick={this.openContactScheda}>{this.state.titleScheda}</Button>
                </Grid>
                <Grid item xs={3} className={this.props.classes.contactReservationButtonContainer}>
                    <Button className={this.props.classes.contactReservationButton} onClick={() => { this.props.openContactReservationDialog() }}>Prenotazioni</Button>
                </Grid>
                <Grid item xs={3} className={this.props.classes.contactReservationButtonContainer}>
                    <Button className={this.props.classes.contactReservationButton} onClick={() => { this.props.openReminderDialog() }}>Promemoria</Button>
                </Grid>
                <Grid item xs={3} className={this.props.classes.contactReservationButtonContainer}>
                    <Button className={this.props.classes.contactReservationButton} onClick={this.openContactAccessi}>Accessi</Button>
                </Grid>
                <Hidden smUp>
                    <Avatar contact={this.props.contact} />
                </Hidden>
                <Grid item sm={8} className={this.props.classes.nameSurnameContainer}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Grid item sm={9} style={{ paddingLeft: '10px' }}>
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    <div style={{ marginRight: '10px', float: 'left', display: 'flex' }}>

                                        <Tooltip placement="right" title={this.getTooltipMessage()}>
                                            {this.getLogo(this.props.contact.sub)}
                                        </Tooltip>

                                        <div id="qrCode" aria-label={this.props.contact.sub} onClick={() => this.openSvg()}>
                                            <QRCode value={this.props.contact.sub} size={100} />
                                        </div>
                                    </div>
                                    {this.props.contact.lastLogin && <>
                                        Ultimo Accesso: <br /><b>{moment(this.props.contact.lastLogin).format("DD/MM/YYYY HH:mm:ss")}</b>
                                    </>}
                                </div>
                            </Grid>
                        </Grid>
                        {/* ROOM */}
                        {(this.props.contact.birthDate && moment(this.props.contact.birthDate).isSame(new Date(), "day")) ?
                            <Grid item sm={12}
                                className={this.props.classes.greenPassContainer}>
                                <TextField
                                    label="Compleanno"
                                    value={this.props.contact.birthDate ? moment(this.props.contact.birthDate).format('D MMMM')
                                        // moment(this.props.contact.birthDate).fromNow()
                                        + " - " + moment().diff(this.props.contact.birthDate, 'years') + " anni" : ''}
                                    disabled
                                    InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                                />
                            </Grid>
                            : <></>}
                        {/* BLOCCO ACCESSO */}
                        <Grid item sm={12} className={!this.isEmpty(this.state.blockAccessOn) ? this.props.classes.blockAccess : this.props.classes.cardNumberContainer} >
                            <Grid item sm={9} style={{ paddingLeft: '10px' }}  >
                                <DatePicker
                                    key={`contact-blockaccesson-from-date-picker`}
                                    label="Data Blocco Accesso"
                                    fullWidth
                                    clearable={true}
                                    value={this.state.blockAccessOn == null ? null : this.state.blockAccessOn}
                                    onChange={(val) => this.setState({ blockAccessOn: val })}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <SaveIconButton onClick={() => this.props.saveBlockAccessDate(this.props.contact.sub, this.state.blockAccessOn)} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Hidden only={'xs'}>
                    <Grid item sm={4}>
                        <Avatar contact={this.props.contact} />
                    </Grid>
                </Hidden>
                <Grid item sm={8} >
                    <Grid item sm={12} className={this.props.classes.cardNumberContainer}>
                        <Grid item sm={9} style={{ paddingLeft: '10px' }}>
                            <TextField
                                label="Numero tessera"
                                value={this.state.cardNumber === undefined ? this.props.contact.cardNumber : this.state.cardNumber}
                                onChange={(val) => this.setState({ cardNumber: val })}
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={3}>
                            {/* <SaveIconButton disabled={!this.state.cardNumber} onClick={() => this.props.saveCardNumber(this.props.contact.sub, this.state.cardNumber)} /> */}
                            <SaveIconButton
                                onClick={() => this.props.saveCardNumber(this.props.contact.sub, this.state.cardNumber)} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={4} style={{ borderColor: '#d6e040', justifyContent: 'center', display: 'flex' }}>
                    <Button className={this.props.classes.contactInformationButton} onClick={() => { this.props.openInformationDialog() }}>Anagrafica</Button>
                </Grid>
                <Grid container>
                    {this.state.showScheda && (<>
                        <Grid item sm={12}>
                            <TextField
                                label="Nome"
                                value={this.props.contact.name}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label="Cognome"
                                value={this.props.contact.surname}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label="Telefono"
                                value={this.props.contact.tel}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label="E-mail"
                                value={this.props.contact.email}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={12}
                            className={(this.props.contact.birthDate && moment(this.props.contact.birthDate).isSame(new Date(), "day")) ? this.props.classes.greenPassContainer : null}>
                            <TextField
                                label="Compleanno"
                                value={this.props.contact.birthDate ? moment(this.props.contact.birthDate).format('D MMMM')
                                    // moment(this.props.contact.birthDate).fromNow()
                                    + " - " + moment().diff(this.props.contact.birthDate, 'years') + " anni" : ''}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label="User Id"
                                value={this.props.contact.sub}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        {/* GREEN PASS 
                        <Grid item sm={12} className={this.props.classes.greenPassContainer}
                            style={this.isExpired(this.state.greenPassExpireOn)}>
                            <Grid item sm={9} style={{ paddingLeft: '10px' }}  >
                                <DatePicker
                                    key={`contact-greenpassexpireon-from-date-picker`}
                                    label="Scadenza GreenPass"
                                    fullWidth
                                    clearable={true}
                                    value={this.state.greenPassExpireOn == null ? null : this.state.greenPassExpireOn}
                                    onChange={(val) => {
                                        this.setState({ greenPassExpireOn: val })
                                    }}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <SaveIconButton onClick={() => this.props.saveGreenPass(this.props.contact.sub, (this.props.contact?.greenPass == null), this.state.greenPassExpireOn)} />
                            </Grid>
                        </Grid>
                        */}

                        {/* <Grid item sm={12} className={this.props.classes.cardNumberContainer}>
                        <Grid item sm={9}>
                            <TextField
                                label="Numero tessera"
                                value={this.state.cardNumber === undefined ? this.props.contact.cardNumber : this.state.cardNumber}
                                onChange={(val) => this.setState({ cardNumber: val })}
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={2}>
                            <SaveIconButton disabled={!this.state.cardNumber} onClick={() => this.props.saveCardNumber(this.props.contact.sub, this.state.cardNumber)} />
                        </Grid>
                    </Grid>
                    <Grid item sm={12} className={this.props.classes.cardNumberContainer}>
                        <Grid item sm={9}>
                            <DatePicker
                                key={`contact-blockaccesson-from-date-picker`}
                                label="Data Blocco Accesso"
                                fullWidth
                                clearable={true}
                                value={this.state.blockAccessOn}
                                onChange={(val) => this.setState({ blockAccessOn: val })}
                            />
                        </Grid>
                        <Grid item sm={2}>
                            <SaveIconButton onClick={() => this.props.saveBlockAccessDate(this.props.contact.sub, this.state.blockAccessOn)} />
                        </Grid>
                    </Grid> */}

                        <Tags tags={this.props.contact.tags} />
                    </>)}
                </Grid>
                <Grid container>
                    {this.state.showAccessi && this.props.contact._id !== "" && (
                        <RoomList
                            updatingRoomsPermissions={this.props.isLoadingContact}
                            roomList={this.props.rooms}
                            contact={this.props.contact}
                            addRoom={this.props.addRoom}
                            removeRoom={this.props.removeRoom}
                            updateRoom={this.props.updateRoom}
                        />
                    )}
                </Grid>
                <Grid container>
                    {this.state.showAbbonamenti && (<>
                        <div style={{ width: '95%' }}>
                            <span style={{ marginTop: '10px', position: 'relative', display: 'block' }}>
                                <Paper title='Abbonamenti e documenti - Aggiungi...' fullHeight contentContainerStyle={{ padding: 8 }} id="SubscriptionDataX">
                                    <Grid container style={{ marginTop: '0px' }}>
                                        <Grid item xs={3} className={this.props.classes.contactSubscriptionsButtonContainer}>
                                            <Button className={this.props.classes.contactSubscriptionsButton} onClick={this.addSubscription}>Abbonamento</Button>
                                        </Grid>
                                        <Grid item xs={3} className={this.props.classes.contactSubscriptionsButtonContainer}>
                                            <Button className={this.props.classes.contactSubscriptionsButton} onClick={this.addMedical}>Visita Medica</Button>
                                        </Grid>
                                        <Grid item xs={3} className={this.props.classes.contactSubscriptionsButtonContainer}>
                                            <Button className={this.props.classes.contactSubscriptionsButton} onClick={this.addInsurance}>{'Iscrizione'}</Button>
                                        </Grid>
                                        <Grid item xs={3} className={this.props.classes.contactSubscriptionsButtonContainer}>
                                            <Button className={this.props.classes.contactSubscriptionsButton} onClick={this.props.openContactAccessDialog}>{'Accesso'}</Button>
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container style={{ marginTop: '0px' }}>
                                        <label style={{ margin: '11px', fontSize: '17px' }}>Filtro Ricerca:</label>
                                        {/* onChange={(e, val) => props.setActivity({ ...activity, isReservable: val })} 
                                            <Checkbox checked={this.state.yesNoQuestion} onChange={this.handleChangeYesNo} /> */}
                                        <FormControlLabel
                                            control={<Checkbox disabled={false} checked={this.state.setFilterAttivi} onChange={this.changeFilterAttivi} />}
                                            label="Solo Attivi"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={false} checked={this.state.setFilterAbbonamenti} onChange={this.changeFilterSubscription} />}
                                            label="Abbonamenti"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={false} checked={this.state.setFilterVisitemediche} onChange={this.changeFilterMedical} />}
                                            label="Visite Mediche"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox disabled={false} checked={this.state.setFilterIscrizione} onChange={this.changeFilterInsurance} />}
                                            label="Iscrizione"
                                        />
                                    </Grid>
                                    <Divider />
                                    <ContactPurchasedList
                                        onSelectItem={(val) => this.setOpenUpdateSubscriptionDialog(true, val)}
                                        contactSubscriptions={this.props.contactSubscriptions}
                                        contactMedicalExaminations={this.props.contactMedical}
                                        contactInsurances={this.props.contactInsurances}
                                        classes={this.props.classes} />
                                </Paper>
                            </span>
                        </div>
                    </>)}
                </Grid>
                <Grid container>
                    <UpdateSubscriptionDialog
                        open={this.state.openUpdateSubscriptionDialog}
                        onCancel={() => this.setOpenUpdateSubscriptionDialog(false, null)}
                        onUpdateInsurance={this.updateInsurance}
                        onDeleteInsurance={this.deleteInsurance}
                        onUpdateMedicalExamination={this.updateMedicalExamination}
                        onDeleteMedical={this.deleteMedicalExamination}
                        onUpdateSubscription={this.updateSubscription}
                        onRemoveSingleAccess={this.removeSingleAccess}
                        onDeleteSubscription={this.deleteSubscription}
                        subscription={this.state.itemToUpdate}
                        userId={this.props.contact.sub}
                    />
                </Grid>
            </Grid> : <></>
        )
    }
}


const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        ...state.rooms,
        ...state.subscriptions,
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    ...roomActions(dispatch),
    ...subscriptionsActions(dispatch),
    ...contactActions(dispatch)
})

export const Contact = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CompContainer));